import React from 'react';
import { Card } from '@material-ui/core';
import cx from 'clsx';
export var QAPanel = function (_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement(Card, { className: cx('faq-panel', className), square: true }, children));
};
//# sourceMappingURL=QAPanel.js.map